











































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import HeaderModule from '~/store/header';
import { Resolve } from 'vue-di';

@Component<Header>({})
export default class Header extends Vue {
    @Prop()
    public brkPoints!: object;

    @Resolve
    public header!: HeaderModule;

    public headerLogoWidth = '';
    get includesProgram() {
        return this.$route.path.includes('somatuline') || this.$route.path.includes('dysport') || this.$route.path.includes('onivyde');
    }

    get headerImageUrl() {
        if (this.header.getHeaderLogo === 'somatuline') {
            this.headerLogoWidth = '378px';
            return this.$settings.url((this.$settings as any).somatuline_logo);
        } else if (this.header.getHeaderLogo === 'dysport') {
            this.headerLogoWidth = '156px';
            return this.$settings.url((this.$settings as any).dysport_logo);
        } else if (this.header.getHeaderLogo === 'onivyde') {
            this.headerLogoWidth = '156px';
            return this.$settings.url((this.$settings as any).onivyde_logo);
        }
        return;
    }

    get isDysport() {
        return this.header.getHeaderLogo === 'dysport';
    }

    get isOnivyde() {
        return this.header.getHeaderLogo === 'onivyde';
    }
    public goHome() {
        this.header.setHeaderLogo('');
        this.$router.push({ name: 'index' });
    }
}
